<script setup lang="ts">
    import { ChevronRight } from 'lucide-vue-next';
    import {
        Dashboard,
        Salary,
        Voucher,
        Bank,
        Vat,
        Administration,
        Settings,
        PowerBI,
    } from '@/components/icons';
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n();

    interface Props {
        result: any;
        context: any;
        contextIndex: number;
        resultIndex: number;
        searchQuery: string;
        isSelected: boolean;
    }

    const props = defineProps<Props>();

    const emit = defineEmits<{
        navigate: [context: any];
    }>();

    const getIconForBreadcrumb = (breadcrumbKey: string) => {
        const iconMap = {
            'menu.dashboards': Dashboard,
            'menu.salary': Salary,
            'menu.voucher': Voucher,
            'menu.bank': Bank,
            'menu.vat': Vat,
            'menu.administration': Administration,
            'menu.settings': Settings,
            'menu.power_bi': PowerBI,
        };

        return iconMap[breadcrumbKey as keyof typeof iconMap];
    };

    const handleClick = (event: Event) => {
        event.preventDefault();
        emit('navigate', props.context);
    };
</script>

<template>
    <a
        :href="context.url"
        :class="isSelected ? 'bg-muted' : 'hover:bg-muted/50'"
        class="text-faded-foreground flex items-center gap-2 rounded-md px-2 py-1.5 text-sm font-normal transition-colors"
        @click="handleClick"
    >
        <div
            class="text-primary h-4 w-4 shrink-0"
            v-if="getIconForBreadcrumb(context.breadcrumb[0])"
        >
            <component
                :is="getIconForBreadcrumb(context.breadcrumb[0])"
                class="text-primary h-full w-full"
            />
        </div>
        <span
            v-for="(crumb, index) in context.breadcrumb"
            :key="index"
            class="inline-flex items-center gap-2"
        >
            <span
                v-if="index > 0"
                class="first:text-primary"
            >
                <ChevronRight class="h-3 w-3" />
            </span>
            <span
                :class="
                    result.name && result.name.trim()
                        ? 'first:text-primary text-faded-foreground'
                        : 'first:text-primary text-foreground'
                "
            >
                {{ $t(crumb) }}
            </span>
        </span>

        <span
            v-if="result.name && result.name.trim()"
            class="inline-flex items-center gap-2"
        >
            <ChevronRight class="h-3 w-3" />
            <span class="text-foreground">
                {{ result.name }}
            </span>
        </span>
    </a>
</template>
